import type { ReactNode } from 'react'

/**
 * Wrapper minimalista — apenas garante a classe `lp-root` (Montserrat) e o
 * background gray-100. A LP segue o site referência: header, hero, grid e
 * footer ficam DENTRO da PlansPage; não há header/footer fixos compartilhados.
 */
export function LpLayout({ children }: { children: ReactNode }) {
  return <div className="lp-root">{children}</div>
}
